import React from 'react';
import { StartDateMod } from './StartDate/StartDateMod';
import { MinReqHoursMod } from './MinReqHours/MinReqHoursMod';
import { EndDateMod } from './EndDate/EndDateMod';
import { EndingTravelMod } from './EndingTravel/EndingTravelMod';
import { PayRateMod } from './PayRate/PayRateMod';
import { ArrivingTravelMod } from './ArrivingTravel/ArrivingTravel';
import { ShiftMod } from './Shift/Shift';
import { LodgingPerDiemAdjustmentMod } from './LodgingPerDiemAdjustMent/LodgingPerDiemAdjustMentMod';
import { InsuranceMod } from './Insurance/InsuranceMod';
import { BillRateMod } from './BillRate/BillRateMod';
import { PtoMod } from './Pto/Pto';
import { OgpIntLoan } from './OgpIntLoan/OgpIntLoan';
import { BonusMod } from './Bonus/BonusMod';
import { ReimbursementMod } from './Reimbursement/ReimbursementMod';
import { TimeOffMod } from './TimeOff/TimeOffMod';
import { EmiLmo } from './EmiLmo/EmiLmo';
import { InterimTravel } from './InterimTravel/InterimTravel';
import { Housing } from './Housing/Housing';
import { FurnitureMod } from './Furniture/FurnitureMod';
import { PreferencesMod } from './Preferences/PreferencesMod';
import { PayrollShiftDiffMod } from './PayrollShiftDiff/PayrollShiftDiffMod';
import { BillingShiftDifferentialMod } from './BillingShiftDifferential/BillingShiftDifferentialMod';

export const ModsComponent = ({ selectedRowDetails }: { selectedRowDetails: any }) => {
  const ModComponents = React.useMemo(
    () => ({
      StartDate: StartDateMod,
      MinReqHours: MinReqHoursMod,
      EndDate: EndDateMod,
      EndingTravel: EndingTravelMod,
      PayRate: PayRateMod,
      LodgingPerDiemAdjustment: LodgingPerDiemAdjustmentMod,
      ArrivingTravel: ArrivingTravelMod,
      Shift: ShiftMod,
      Insurance: InsuranceMod,
      BillRate: BillRateMod,
      PTO: PtoMod,
      OGPIntlLoan: OgpIntLoan,
      Bonus: BonusMod,
      Reimbursement: ReimbursementMod,
      Timeoff: TimeOffMod,
      EMILMO: EmiLmo,
      InterimTravel: InterimTravel,
      Housing: Housing,
      Furniture: FurnitureMod,
      Preferences: PreferencesMod,
      PayrollShiftDifferential: PayrollShiftDiffMod,
      BillingShiftDifferential: BillingShiftDifferentialMod,
    }),
    [],
  );

  const Component = ModComponents[selectedRowDetails?.type?.replaceAll(/['/.\s]/g, '')];
  return <>{Component ? <Component /> : null}</>;
};
